export const TEAME_223_FLAG_ID = 'TEAME-223-FutureSelves-AB';

/** The arm that gets the future-self avatar. Everyone else, control included, gets the baseline. */
export const TEAME_223_TREATMENT = 'treatment';
